import { auth } from "@/components/login-modal/login-modal";
import { AuthResource } from "../resources/auth-resource";
import {
  ClientPhoneCheckResponse,
  ClientPhoneRequest,
  ClientPhoneResponse,
} from "../types/auth";

export const AuthRepository = {
  /**
   * Отправка номера телефона для аутентификации
   * @param phone Номер телефона в формате "+7XXXXXXXXXX"
   */
  async sendPhone(phone: ClientPhoneRequest): Promise<ClientPhoneResponse> {
    const response = await AuthResource.sendPhone(phone);
    return response;
  },

  /**
   * Проверка кода подтверждения
   * @param params Объект с номером телефона и кодом подтверждения
   */
  async verifyPhone(params: {
    phone: string;
    code: string;
  }): Promise<ClientPhoneCheckResponse> {
    const response = await AuthResource.verifyPhone(params);

    // Сохраняем токен после успешной верификации
    if (response.token) {
      auth(response.token);
    }

    return response;
  },
};
